import type { FileUploadRequestInput } from '../modules/organization/types'

export const getLogoName = (file: File): string => {
	return `logo.${file.name.split('.').pop()}`
}

export const getLogoUploadData = (organizationId: string, logo: File): FileUploadRequestInput => {
	return {
		filename: getLogoName(logo),
		// Server-side schema constrains mimetype to a strict allow-list (Wrike
		// 4409828829 / MA1.1). Logos are restricted to image/* in the picker, so
		// the runtime value is always within the enum even though `File.type` is
		// typed loosely as string upstream.
		mimetype: logo.type as FileUploadRequestInput['mimetype'],
		size: logo.size,
		organizationId: organizationId,
	}
}
